{
  "name": "@rio/useradministration-web",
  "version": "2.0.0",
  "private": true,
  "type": "module",
  "scripts": {
    "start": "vite --port 3013 --force",
    "start:localprod": "sh -ac '. ./.env.localprod; npm run start'",
    "build": "vite build && rimraf ./build/mockServiceWorker.js",
    "preview": "vite preview",
    "test": "tsc -b && vitest run",
    "test-ci": "npm test -- --reporter=dot --reporter=junit --outputFile.junit=./results/junit.xml",
    "test-dev": "vitest",
    "coverage": "vitest run --coverage",
    "audit": "npm audit --registry https://registry.npmjs.org --audit-level=moderate --omit=dev",
    "lint": "biome check .",
    "lint-fix": "biome check --write .",
    "format-code": "biome format --write .",
    "format-code-on-commit": "npm run format-code && git add",
    "pull-translations": "phrase pull --access_token $PHRASEAPP_ACCESS_TOKEN && npm run merge-translations",
    "merge-translations": "node ./mergeTranslations.cjs && rm -rf src/features/translations/temp",
    "playwright-test": "playwright test",
    "playwright-open": "playwright test --ui",
    "msw-init": "msw init public --save=false",
    "playwright-install": "playwright install --with-deps chromium",
    "playwright-setup": "npm run msw-init && npm run playwright-install"
  },
  "dependencies": {
    "@hookform/resolvers": "5.9.1",
    "@reduxjs/toolkit": "2.13.0",
    "@rio-cloud/iframe-resizer": "1.1.2",
    "@rio-cloud/rio-notifications-component": "2.0.0",
    "@rio-cloud/rio-order-chat-component": "0.7.0",
    "@rio-cloud/rio-session-expired-info": "2.0.0",
    "@rio-cloud/rio-uikit": "3.0.0",
    "@rio-cloud/rio-user-menu-component": "5.0.0",
    "@sentry/browser": "11.4.0",
    "classnames": "2.5.1",
    "configcat-react": "5.1.0",
    "jwt-decode": "3.1.2",
    "lodash": "4.18.1",
    "oidc-client-ts": "3.5.0",
    "ramda": "0.32.0",
    "react": "19.3.0",
    "react-dom": "19.3.0",
    "react-hook-form": "7.89.0",
    "react-intl": "7.1.14",
    "react-markdown": "10.1.0",
    "react-redux": "9.3.0",
    "react-router": "7.18.4",
    "uuid": "14.0.2",
    "zod": "4.6.5"
  },
  "devDependencies": {
    "@biomejs/biome": "2.5.15",
    "@playwright/test": "1.63.0",
    "@rio-cloud/rio-license-checker": "1.3.0",
    "@rio-cloud/vite-plugin-frontend-license-check": "3.1.1",
    "@testing-library/jest-dom": "7.0.1",
    "@testing-library/react": "16.3.3",
    "@testing-library/user-event": "14.6.7",
    "@types/lodash": "4.17.25",
    "@types/ramda": "0.32.0",
    "@types/react": "19.3.0",
    "@types/react-dom": "19.3.0",
    "@vitejs/plugin-react": "6.1.2",
    "jsdom": "30.1.2",
    "msw": "3.0.2",
    "rimraf": "6.1.3",
    "rollup-plugin-visualizer": "7.1.1",
    "typescript": "5.9.3",
    "vite": "8.3.3",
    "vitest": "5.0.3"
  },
  "browserslist": [
    "last 5 Chrome versions",
    "Firefox >= 147",
    "last 5 Edge versions",
    "Safari >= 26"
  ],
  "msw": {
    "workerDirectory": "public"
  },
  "overrides": {
    "moment": ">2.30.1"
  }
}
